import React from 'react';
import './Pagination.scss';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  disabled = false,
}: PaginationProps) {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="pagination">
      <button
        className="btn btn--ghost"
        onClick={handlePrevious}
        disabled={disabled || currentPage <= 1}
      >
        Prev
      </button>
      <div className="pagination__label">
        Page {currentPage} / {totalPages}
      </div>
      <button
        className="btn btn--ghost"
        onClick={handleNext}
        disabled={disabled || currentPage >= totalPages}
      >
        Next
      </button>
    </div>
  );
}
